import React from "react";

const AboutSection = ({ patternCanvas1Ref }) => {
  return (
    <section className="py-24 scroll-animation opacity-0 translate-y-8 transition-all duration-800 ease-out">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <canvas
              ref={patternCanvas1Ref}
              className="w-full aspect-square rounded-2xl"
              width="500"
              height="500"
            ></canvas>
          </div>
          <div className="text-2xl md:text-3xl text-slate-300 space-y-8 font-medium">
            <p className="leading-relaxed">
              <span className="bg-gradient-to-r from-blue-400 via-emerald-400 to-yellow-400 bg-clip-text text-transparent opacity-0 transition-opacity duration-[1500ms] ease-in-out">
               The most configurable AI for booking hotels. Our Brand empowers users with seamless, voice-driven conversations to find and book the perfect stay.
              </span>
            </p>
            <p className="leading-relaxed">
              <span className="bg-gradient-to-r from-blue-200 via-emerald-400 to-yellow-400 bg-clip-text text-transparent opacity-0 transition-opacity duration-[1500ms] ease-in-out delay-500">
                From simple voice commands to completing the entire hotel booking process, our platform delivers a natural and efficient experience.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
